module.exports = __webpack_public_path__ + "img/80726C_DCDBD7_9AA6C2_B7BFCA-256px.4b15adf3.png";